"use strict";

exports.__esModule = true;
exports["default"] = getPropsWithPrefix;

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.regexp.replace");

function removePrefix(prefix, str) {
  var strWithoutPrefix = str.replace(new RegExp(prefix), '');
  return strWithoutPrefix[0].toLowerCase() + strWithoutPrefix.slice(1);
}

function getPropsWithPrefix(prefix, props) {
  var propNames = Object.keys(props).filter(function (propName) {
    return propName.startsWith(prefix);
  });
  var propsWithPrefixRemoved = propNames.reduce(function (accum, propName) {
    var _Object$assign;

    return Object.assign({}, accum, (_Object$assign = {}, _Object$assign[removePrefix(prefix, propName)] = props[propName], _Object$assign));
  }, {});
  return [propsWithPrefixRemoved, propNames];
}